// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentRelationshipModel {
    static getAttributeTypeMap() {
        return DocumentRelationshipModel.attributeTypeMap;
    }
}
DocumentRelationshipModel.discriminator = undefined;
DocumentRelationshipModel.additionalProperties = false;
DocumentRelationshipModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "comment",
        "baseName": "comment",
        "type": "string"
    },
    {
        "name": "isHidden",
        "baseName": "isHidden",
        "type": "boolean"
    },
];
//# sourceMappingURL=documentRelationshipModel.js.map